import React from 'react';
import CustomerTableList from '../components/CustomerTableList';
import PageLayout from '../components/layout/PageLayout';

const CustomerListPage = () => (
  <PageLayout>
    <CustomerTableList />
  </PageLayout>
);

export default CustomerListPage;
